import axios, { CancelTokenSource } from 'axios';

export async function getGsProducts(source: CancelTokenSource, params?: any) {
  return axios.get(`alf_products/`, { params: params, cancelToken: source.token })
    .then(response => response.data);
};